import React from 'react'
import Layout from '../../../components/Default/Layout'
import ServiceHeader from '../../../components/Services/ServiceOverview/ServiceHeader'
import '../../../components/ParagraphUnderPhoto/styles.css'
import { graphql } from 'gatsby'
import { Breadcrumb } from 'gatsby-plugin-breadcrumb'
import './styles.css'
import styled from 'styled-components'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'

export const Dane = ({ data: { page }, pageContext }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  }
  const { frontmatter } = page
  const {
    breadcrumb: { crumbs },
  } = pageContext

  const Square = styled.div`
    cursor: pointer;
    transition: all 250ms ease-in;
    background-color: ${({ active }) => (active ? '#d5d110' : 'transparent')};
    color: ${({ active }) => (active ? '#fff' : '333')};
    transform: scale(${({ active }) => (!active ? 1.1 : 1)});
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 10px;
    border: 2px solid #d5d110 !important;
    height: 10px !important;
    width: 55px !important;
    border-radius: 11px !important;
    box-shadow: none !important;
  `
  const Flex = styled.div`
    display: flex;
    flex-direction: ${({ direction }) => direction};
  `

  const Button = styled.button`
    background: none;
    border: none;
    font-size: 2.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    user-select: none;
    &:disabled {
      cursor: not-allowed;
    }
  `
  /*
  const myArrow = ({ type, onClick, isEdge }) => {
    const pointer = type === consts.PREV ? '<' : '>'
    return (
      <Button onClick={onClick} disabled={isEdge}>
        {pointer}
      </Button>
    )
  }
*/
  return (
    <>
      <Layout
        meta={page.frontmatter.meta || false}
        title={page.frontmatter.title || false}
        metaCrumb={crumbs}
      >
        <ServiceHeader
          title={frontmatter.title}
          backgroundImage={
            !!frontmatter.image.childImageSharp
              ? frontmatter.image.childImageSharp.fluid.src
              : frontmatter.image
          }
        />
        <Breadcrumb crumbs={crumbs} crumbLabel={'Napsali o nás'} />

        <div className="container WriteAboutUs--Wrapper">
          <Carousel
            responsive={responsive}
            additionalTransfrom={0}
            arrows
            autoPlaySpeed={3000}
            centerMode={false}
            className="WriteAboutUs-Wrap-Carousel"
            dotListClass=""
            draggable
            focusOnSelect={false}
            infinite
            itemClass=""
            keyBoardControl
            minimumTouchDrag={80}
            renderButtonGroupOutside={true}
            renderDotsOutside={false}
            showDots={true}
            dotListClass="custom-dot-list-style"
          >
            <div className="CardWrap">
              <span>Hospodářské noviny</span>
              <p>
                Dne 21.května 2020 odpovídal partner EKP Lukáše Eisenwort na
                dotazy čtenářů Hospodářských novin v online rozhovoru ve věci
                zdanění příjmů z investic.
              </p>
              <div className="ButtonWrap">
                <a
                  href="https://byznys.ihned.cz/c1-66765800-vydelal-jsem-na-revolutu-a-jde-po-mne-bernak-jak-takove-situaci-predejit-ptejte-se-danoveho-experta"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Více
                </a>
              </div>
            </div>
            <div className="CardWrap">
              <span>Bitcoin meetup</span>
              <p>
                V úterý 20. března 2O2O jsme v prostorách Paralelní Polis
                uspořádali přednášku s názvem Virtuální měny v daních. Hlavním
                přednášejícím byl jeden z našich partnerů Jan Kotala, střídali
                ho kolega Michal Friedrich a JUDr. Josef Žaloudek z Havel &
                Partners, s.r.o.
              </p>
              <div className="ButtonWrap">
                <a
                  href="https://www.youtube.com/watch?v=9tUor_g-Kr4&feature=emb_title"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Více
                </a>
              </div>
            </div>
            <div className="CardWrap">
              <span>Hospodářské noviny</span>
              <p>
                Evropská komise představila první část návrhů, jak reformovat
                nejvýznamnější daň v Evropě - DPH U stanovení sazeb DPH navrhuje
                obrátit současnou praxi - stanoví několik věcí, jako například
                alkohol nebo zbraně, u nichž nesmí DPH klesnout pod 15 procent,
                u zbytku si státy mohou sazbu libovolně zvolit.
              </p>
              <div className="ButtonWrap">
                <a
                  href="https://archiv.ihned.cz/c1-66021960-evropska-komise-predstavila-cast-reformy-dph-sazby-si-maji-vybirat-samy-staty"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Více
                </a>
              </div>
            </div>
            <div className="CardWrap">
              <span>Hospodářské noviny</span>
              <p>
                Odlišné daňové systémy v Evropské unii vytvořily cestičky pro
                vyvádění peněz fyzicky ven. "Dokud v EU nedosáhneme sladění
                přímých daní, což je cesta na roky, možná desetiletí, bude vždy
                existovat nějaká cestička k vyvádění zisku," říká Lukáš
                Eisenwort, daňový poradce a partner ve společnosti EK Partners,
                s.r.o. o aktuálním tématu odhalených dokumentů o ukrývání
                majetku v daňových rájích známém jako Paradise Papers.
              </p>
              <div className="ButtonWrap">
                <a
                  href="https://zahranicni.ihned.cz/c1-65951720-vyuzivani-danovych-raju-je-v-cesku-na-ustupu-dokud-eu-nesladi-dane-cesta-vyvadet-penize-tu-bude-vzdy-rika-danovy-poradce"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Více
                </a>
              </div>
            </div>
            <div className="CardWrap">
              <span>Bulletin KDP ČR</span>
              <p>
                K důkaznímu břemenu u karuselových podvodů aneb Věděl, nebo
                vědět měl a mohl
              </p>
              <div className="ButtonWrap">
                <a
                  href="/files/Bulletin2_2017.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Více
                </a>
              </div>
            </div>
            <div className="CardWrap">
              <span>Hospodářské noviny</span>
              <p>
                V případě schválení tzv. Lex Babiš, zahájí ministr financí
                největší přesun soukromého majetku v Česku. by vyhověl zákonu a
                jeho firmy mohly přitom dál pobírat dotace a ucházet se o
                veřejné zakázky, předá firmy do svěřenského fondu. Obří holding
                Agrofert a dalších 250 firem zastřeší jediná společnost Agabsy a
                ocitnou se bez majitele v rukou správce fondu. Tím však může být
                samotný Babiš. "Podnikatel si tak může zachovat nezměněný vliv
                na chod firem," řekl
              </p>
              <div className="ButtonWrap">
                <a
                  href="https://archiv.ihned.cz/c1-65581670-babisuv-byznys-v-hodnote-desitek-miliard-zastresi-jediny-fond-bude-nejvetsi-v-cesku"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Více
                </a>
              </div>
            </div>
            <div className="CardWrap">
              <span>Aktuálně.cz</span>
              <p>
                Babišovo snížení daně se na ceně piva neprojeví, říkají
                odborníci. Uškodí malým hospodám? <br />
                Lukáš Eisenwort reaguje na Babišův návrh snížení daní: „Babiš,
                nebude to mít na jeho cenu žádný vliv, tvrdí odborníci. „Ze
                zkušenosti se změnami daní víme, že jakékoli snížení se promítne
                v daleko menší míře, než by mělo. Někdy se neprojeví vůbec.“
              </p>
              <div className="ButtonWrap">
                <a
                  href="https://zpravy.aktualne.cz/ekonomika/babisovo-snizeni-dane-se-na-cene-piva-neprojevi/r~6355e1b4c68511e59e52002590604f2e/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Více
                </a>
              </div>
            </div>
            <div className="CardWrap">
              <span>Hospodářské noviny</span>
              <p>
                Část akcionářů vytěsněných z firmy Cetin bude řešit daně. Ale
                budou vůbec v zisku? <br />
                Přečtěte si vyjádření Lukáše Eisenwort, který reaguje na
                převzetí akcií společnosti Cetin společností PPF.A4B.V.
              </p>
              <div className="ButtonWrap">
                <a
                  href="https://byznys.ihned.cz/c1-65057160-cast-akcionaru-vytesnenych-z-firmy-cetin-bude-resit-dane-ale-budou-vubec-v-zisku"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Více
                </a>
              </div>
            </div>
            <div className="CardWrap">
              <span>Hospodářské noviny</span>
              <p>
                Evropská komise představila první část návrhů, jak reformovat
                nejvýznamnější daň v Evropě - DPH U stanovení sazeb DPH navrhuje
                obrátit současnou praxi - stanoví několik věcí, jako například
                alkohol nebo zbraně, u nichž nesmí DPH klesnout pod 15 procent,
                u zbytku si státy mohou sazbu libovolně zvolit.
              </p>
              <div className="ButtonWrap">
                <a
                  href="https://www.youtube.com/watch?v=9tUor_g-Kr4&feature=emb_title"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Více
                </a>
              </div>
            </div>
          </Carousel>
        </div>
      </Layout>
    </>
  )
}
export default Dane

export const pageQuery = graphql`
  query NapsaliONas {
    page: markdownRemark(frontmatter: { slug: { eq: "o-nas/napsali-o-nas" } }) {
      frontmatter {
        meta {
          canonicalLink
          description
          noindex
          title
        }
        title
        image {
          childImageSharp {
            fluid(maxWidth: 2048, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
